import React from "react";

function NotFoundPage(props) {
  console.log(props.match)
  return (
    <div style={{ padding: "50px", width: "100%", textAlign: "center" }}>
      <h3>Oops! Looks like you're trying to access Sutra Instructor Dashboard</h3>
      <p>Please try using a different url, for example: sutrapro.com/joshua</p>
      <a href={"/forgotpass"}>Forgot Password?</a>
    </div>
  );
}

export default NotFoundPage;
